// removed by extract-text-webpack-plugin
module.exports = {"booking-confirmation":"booking-confirmation_booking-confirmation--1rVetSNV","bookingConfirmation":"booking-confirmation_booking-confirmation--1rVetSNV","appointmentDetails":"booking-confirmation_appointmentDetails--3y_6kkxq"};


//////////////////
// WEBPACK FOOTER
// ./components/book-appointment/src/styles/booking-confirmation.scss
// module id = 1658
// module chunks = 0